<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        탐지
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">탐지</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> 탐지 목록
      </template> -->
      <b-card v-show="so.adv">
        <b-card v-show="so.adv">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="opt_date"> 탐지일
                  <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
                </label>
                <b-form inline>
                  <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="opt_mod">격리 여부</label>
                <br>
                <select v-model="so.opt['is_backup']" @change="refresh">
                  <option disabled value="">Please select Mode</option>
                  <option value='false'>Off</option>
                  <option value='true'>On</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="opt_os_type">운영 체제</label>
                <br>
                <select v-model="so.opt['agent.os_type']" @change="refresh">
                    <option disabled value="">select Enable or Disable</option>
                    <option value="windows">Windows</option>
                    <option value="linux">Linux</option>
                  </select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="opt_ip_addr">IP 주소</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_ip_addr" v-model="so.opt['agent.ip_addr']"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="opt_host">Host</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_host" v-model="so.opt['agent.host']"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="opt_name">이름</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['agent.name']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <label for="ph_search_opt_type">필터 유형</label>
              <b-form-group>
                <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                  <b-form-radio value="and">[AND]:모두 포함</b-form-radio>
                  <b-form-radio value="or">[OR]:하나라도 포함</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group class="float-right">
            <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 검색 </b-button>
            <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
            <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
          </b-form-group>
        </b-card>
      </b-card>
      <b-row>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-form inline>
              <span class="mr-2">검색 기간</span>
              <date-picker v-if="i18n" @change="$refs._list && $refs._list.refresh()" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang[i18n ? i18n.toLowerCase() : 'en']" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker v-if="i18n" @change="$refs._list && $refs._list.refresh()" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang[i18n ? i18n.toLowerCase() : 'en']" :confirm="false" :first-day-of-week="1"></date-picker>

              <b-btn class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-1, 'day'); $refs._list.refresh() }" size="sm" variant="info">-1</b-btn>
              <b-btn class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-7, 'day'); $refs._list.refresh() }" size="sm" variant="info">-7</b-btn>
              <b-btn class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-30, 'day'); $refs._list.refresh() }" size="sm" variant="info">-30</b-btn>
            </b-form>
          </b-input-group>
        </b-input-group>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'"  size="sm" variant="outline-secondary">
                  <b-dropdown-item size="sm"  @click="so.sk='agent.name'; so.skt='이름'">이름</b-dropdown-item>
                  <b-dropdown-item size="sm"  @click="so.sk='path'; so.skt='Path'">Path</b-dropdown-item>
                  <b-dropdown-item size="sm"  @click="so.sk='agent.ip_addr'; so.skt='IP'">IP</b-dropdown-item>
                  <b-dropdown-item size="sm"  @click="so.sk='agent.host'; so.skt='Host Name'">Host</b-dropdown-item>
                </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()" ><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary"  @click="search_opt"><i :class="'fa ' + (so.adv ? 'fa-search-minus' : 'fa-search-plus')"> 상세 검색</i></b-btn>
              <!-- <b-btn variant="outline-secondary" v-show="so.adv" @click="search_opt"><i class="fa fa-search-minus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}} </template>
        <template slot="agent" slot-scope="row" v-if="row.item.agent">
          <span v-if="row.item.agent.name == row.item.agent.host">
            {{row.item.agent.host}}@{{row.item.agent.ip_addr_public}}
            <span v-if="row.item.agent.ip_addr_private != row.item.agent.ip_addr_public">
              ({{row.item.agent.ip_addr_private}})
            </span>
          </span>
          <span v-else>
            {{row.item.agent.name}} ({{row.item.agent.host}}@{{row.item.agent.ip_addr_public}})
            <span v-if="row.item.agent.ip_addr_private != row.item.agent.ip_addr_public">
              ({{row.item.agent.ip_addr_private}})
            </span>
          </span>
        </template>
        <template slot="path" slot-scope="row">{{row.item.path}}</template>
        <template slot="created_at" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.created_at | datetime}}
          </a>
        </template>
        <!-- <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">더 보기</b-btn>
        </template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :limit="5" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
      </b-row>
    </b-card>

    <!-- 시작 및 마지막 날짜 유무 확인 모달-->
    <b-modal title="기간 설정" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      시작 날짜 및 마지막 날짜를 지정해야 조회가 가능합니다.
    </b-modal>

     <!-- 기간 설정 범위제한 모달-->
     <b-modal title="기간 설정" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      탐지 목록은 최대 1년단위로 조회가 가능합니다.
    </b-modal>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>

</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
